import React, { useEffect, useState } from 'react';
import { useLogin } from '../reducers';
import { connectOnlinePresence, PresenceState } from '../api/presence';
import ElencoPresenze from './ElencoPresenze';
import './PresenzeOnline.scss';

const OPEN_KEY = 'owlitrack:online-panel-open';

const OnlinePanel = ({ participantId }: { participantId: number }) => {
  const [presence, setPresence] = useState<PresenceState>({ status: 'connecting', participants: [] });
  const [expanded, setExpanded] = useState(() => {
    try {
      return window.localStorage.getItem(OPEN_KEY) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => connectOnlinePresence(setPresence), []);

  const toggle = () => {
    const next = !expanded;
    setExpanded(next);
    try {
      window.localStorage.setItem(OPEN_KEY, String(next));
    } catch {
      // The panel still works when browser storage is unavailable.
    }
  };
  const connected = presence.status === 'connected';
  const count = presence.participants.length;
  const label = connected ? `${count} ${count === 1 ? 'persona online' : 'persone online'}`
    : presence.status === 'connecting' ? 'Connessione presenze…' : 'Presenze non disponibili';

  return <aside className="online-presence" aria-label="Persone online">
    <button type="button" className="online-presence-toggle" aria-expanded={expanded}
      aria-controls="online-presence-details" onClick={toggle}
      title={expanded ? 'Chiudi elenco delle persone online' : 'Mostra le persone online'}>
      <i className={`fa fa-circle ${connected ? 'text-success' : 'text-muted'}`} aria-hidden="true" />
      <span role="status">{label}</span>
      <i className={`fa ${expanded ? 'fa-times' : 'fa-chevron-up'}`} aria-hidden="true" />
    </button>
    {expanded && <div id="online-presence-details" className="online-presence-details">
      {connected ? count ? <ElencoPresenze participants={presence.participants} currentParticipantId={participantId} />
        : <p className="small text-muted mb-0">Nessuna persona online.</p>
        : <p className="small text-muted mb-0">{presence.status === 'connecting' ? 'In attesa delle presenze…'
          : presence.status === 'unavailable' ? 'Presenze non disponibili per questa sessione.' : 'Riconnessione in corso…'}</p>}
    </div>}
  </aside>;
};

const PresenzeOnline = () => {
  const login = useLogin();
  return login.logged_in && login.user.attivo
    ? <OnlinePanel key={login.user.id} participantId={login.user.id} /> : null;
};

export default PresenzeOnline;
